import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=5c4e3086&scoped=true&"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e3086",
  null
  
)

export default component.exports